module.exports = __webpack_public_path__ + "static/img/ranking_center_img.9c5719a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ranking_center_img.png
// module id = MqQo
// module chunks = 0